import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../../../../src/core/api/axiosClient";

const initialState: any = {
  burnTimeReports: [],
  isLoadingBurnTimeReports: false,
  isLoading: false,
  error: null,
  burnTimeReportsDownload: [],
  isLoadingBurnTimeReportsDownload: false,
};

export const getBurnTimeReports: any = createAsyncThunk(
  "content/getBurnTimeReports",
  async ({
    tcCode = null,
    siteCode = null,
    blockCode = null,
    reportType = null,
    startDate = null,
    endDate = null,
    asset = null,
  }: any) => {
    const payload = {
      tcCode,
      siteCode,
      blockCode,
      reportType,
      startDate,
      endDate,
      asset,
    };
    const res = await axios.post(`/slpapp/Report/getBurnTimeReport`, payload, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    const data = await res.data;
    return data;
  },
);

export const downloadBurnTimeReportsFile: any = createAsyncThunk(
  "content/downloadBurnTimeReportsFile",
  async ({
    fileType = "downloadPdf",
    tcCode = null,
    siteCode = null,
    blockCode = null,
    reportType = null,
    startDate = null,
    endDate = null,
    asset = null,
  }: any) => {
    const payload = {
      tcCode,
      siteCode,
      blockCode,
      reportType,
      startDate,
      endDate,
      asset,
    };

    try {
      const response = await axios.post(
        `/slpapp/Report/getBurnTimeReport/${fileType}`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
          },
          responseType: "blob",
        },
      );

      let filename = response.headers["content-disposition"]
        .split(";")
        .find((n: any) => n.includes("filename="))
        .replace("filename=", "")
        .trim();

      let fileBlob;
      if (fileType === "downloadPdf") {
        fileBlob = new Blob([response.data], { type: "application/pdf" });
      } else {
        fileBlob = new Blob([response.data], {
          type: "application/application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
      }

      const fileUrl = URL.createObjectURL(fileBlob);

      const link = document.createElement("a");
      link.href = fileUrl;
      link.download = filename;

      link.click();

      URL.revokeObjectURL(fileUrl);

      return response.data;
    } catch (error) {
      console.error("Error downloading burn time report:", error);
      throw error;
    }
  },
);

export const burnTimeReportSlice = createSlice({
  name: "burnTimeReport",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getBurnTimeReports.pending, (state) => {
      state.isLoadingBurnTimeReports = true;
    });
    builder.addCase(getBurnTimeReports.fulfilled, (state, action) => {
      state.isLoadingBurnTimeReports = false;
      state.burnTimeReports = action.payload;
    });
    builder.addCase(getBurnTimeReports.rejected, (state, action) => {
      state.isLoadingBurnTimeReports = false;
      state.error = action.error.message;
    });

    builder.addCase(downloadBurnTimeReportsFile.pending, (state) => {
      state.isLoadingBurnTimeReportsDownload = true;
    });
    builder.addCase(downloadBurnTimeReportsFile.fulfilled, (state, action) => {
      state.isLoadingBurnTimeReportsDownload = false;
      state.burnTimeReportsDownload = action.payload;
    });
    builder.addCase(downloadBurnTimeReportsFile.rejected, (state, action) => {
      state.isLoadingBurnTimeReportsDownload = false;
      state.error = action.error.message;
    });
  },
});

export default burnTimeReportSlice.reducer;
